<template>
  <div class="financials-widget-page">
    <FinancialsWidget
      :has-financials="hasFinancials"
      :credit-risk-rating="getRiskLabelFromScore(simulatedScore)"
      :financials-data="mockFinancialsData"
    />

    <div class="floating-controls">
      <label>
        <input
          v-model="hasFinancials"
          type="checkbox"
        > Has Financials
      </label>

      <label>
        Credit Score:
        <select v-model.number="simulatedScore">
          <option
            v-for="score in 7"
            :key="score"
            :value="score"
          >
            {{ score }}
          </option>
        </select>
      </label>

      <button
        class="button-primary"
        @click="toggleSimulation"
      >
        {{ isSimulated ? 'Reset to Default Values' : 'Simulate Figma Values' }}
      </button>
    </div>
  </div>
</template>

<script>
import FinancialsWidget from '@/components/widget/financials/index.vue';

export default {
  name: 'FinancialsWidgetPage',
  components: {
    FinancialsWidget
  },
  data() {
    return {
      hasFinancials: false,
      simulatedScore: 1,
      isSimulated: false,
      mockFinancialsData: {}
    };
  },
  created() {
    this.resetDefaults();
  },
  methods: {
    toggleSimulation() {
      if (this.isSimulated) {
        this.resetDefaults();
      } else {
        this.loadFigmaMockup();
      }
      this.isSimulated = !this.isSimulated;
    },
    resetDefaults() {
      this.hasFinancials = false;
      this.simulatedScore = 1;
      this.mockFinancialsData = {
        debtCoverage: { rawValue: 1.0, score: 3 },
        profitability: { rawValue: 0.01, score: 3 },
        liquidity: { rawValue: 1.0, score: 3 },
        leverage: { rawValue: 5, score: 3 },
        capitalAdequacy: { rawValue: 10000, score: 3 },
        collateralCoverage: { rawValue: 1.8, score: 3 },
        guarantorStrength: { rawValue: 50000, score: 3 }
      };
    },
    loadFigmaMockup() {
      this.hasFinancials = true;
      this.simulatedScore = 1;
      this.mockFinancialsData = {
        debtCoverage: { rawValue: 1.2, score: 2 },
        profitability: { rawValue: 0.25, score: 1 },
        liquidity: { rawValue: 1.8, score: 2 },
        leverage: { rawValue: 2.1, score: 2 },
        capitalAdequacy: { rawValue: 450000, score: 1 },
        collateralCoverage: { rawValue: 1.25, score: 3 },
        guarantorStrength: { rawValue: 275000, score: 1 }
      };
    },
    getRiskLabelFromScore(score) {
      return {
        1: 'Minimal Risk',
        2: 'Modest Risk',
        3: 'Average Risk',
        4: 'Active Monitor',
        5: 'Special Mention',
        6: 'Watch List',
        7: 'Substandard'
      }[score] || '';
    }
  }
};
</script>

<style scoped lang="scss">
.financials-widget-page {
  @include stack-space($space-large);
  @include inset-space($space-large);

  .floating-controls {
    position: fixed;
    top: $space-medium;
    right: $space-medium;
    background: rgba($color-white, 0.95);
    border: 1px solid $color-neutral-light;
    border-radius: $radius-medium;
    padding: $space-medium;
    z-index: $z-index-dialog;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    display: flex;
    flex-direction: column;
    gap: $space-small;

    label {
      font-weight: bold;
      font-size: 0.875rem;
      display: flex;
      flex-direction: column;
      gap: $space-xsmall;
    }

    select {
      padding: $space-xsmall;
      font-size: 0.875rem;
    }

    button {
      margin-top: $space-small;
      padding: $space-xsmall $space-small;
      color: $color-white;
      font-size: 0.875rem;
      border: none;
      border-radius: $radius-small;
      cursor: pointer;
    }
  }

  @media (max-width: 600px) {
    .floating-controls {
      position: static;
      margin-top: $space-large;
      width: 100%;
      background: none;
      border: none;
      box-shadow: none;
      padding: 0;
      gap: $space-medium;

      label,
      select,
      button {
        font-size: 1rem;
      }
    }
  }
}
</style>
